// extracted by mini-css-extract-plugin
export default {"container":"VBCharacterLimit_container__JuHQ4","over":"VBCharacterLimit_over__3bN4S"};